"use client";
import Industries from "@/components/Industries";

export default function IndustryPage() {
  return <Industries />;
}
